module.exports = __webpack_public_path__ + "assets/img/Logitech-G-4-Social-Static-Ad-w720.340d8b55.png";